<template>
    <div class="tableRow" :style="[rowStyle]" @click="onClick">
        <div class="tableCell"
             :data-key="getFieldKey(col.name)"
             v-for="col in columns" :key="col.name"
             :class="{ 'numberFormat': isNumberFormat(col) }">
            <span class="tableCell__content" :class="{'--clickable': col.isClickable, 'showInfoPopup': col.infoIcon }">
                <slot :source="data[col.name]">
                    {{ getFieldValue(col) }}
                </slot>
            </span>
        </div>
    </div>
</template>

<script>


import {formatByType, isNumberColumn} from "@/2_app-logic/utils/utils";

export default {
    name: 'zTableRow',
    props: {
        data: Object,
        columns: Array,
        columnsNameMap: Object,
        rowStyle: Object,
    },
    data: () => ({
        isNumberFormat: isNumberColumn,
    }),
    computed: {},
    methods: {
        getFieldKey(name) {
            // if (!this.columnsNameMap) console.warn('Не назначен columnsNameMap', name)
            return this.columnsNameMap ? this.columnsNameMap[name] : name
        },
        getFieldValue(col) {
            const result = formatByType[col.type](this.data[this.getFieldKey(col.name)])
            // console.log(result, col.name, col.type);
            return result
        },
        onClick(event) {
            const target = event.target
            
            const cellEl = target.closest('.tableCell')
            const key = cellEl.dataset.key
            
            if (key === 'name') this.$emit('onNameClick', this.data.id)
            
            if (target.closest('.showInfoPopup')) this.$emit('onInfoClick', { key, rowData: this.data })
        },
    },
}
</script>


<style scoped lang="less">

</style>